import React from 'react'
import PropTypes from 'prop-types'

import { Button, QuickviewBottomSheet, QuickviewPopup } from '../../../index'
import { useVisibility } from '../../../../utils'
import { useMediaResize, useTranslation } from '../../../../utils/providers'

function VariantButton({ productData, className, variant, text }) {
  const { t } = useTranslation()
  const { breakpoints } = useMediaResize()
  const { isVisible, show, hide } = useVisibility()

  const btnText = text || t('PRODUCT_TILE_CHOSE_VARIANT')

  const QuickviewComponent = breakpoints.downMD
    ? QuickviewBottomSheet
    : QuickviewPopup

  return (
    <>
      <Button
        className={className}
        variant={variant}
        onClick={show}
        data-testid="btn-choose-variant"
      >
        {btnText}
      </Button>
      {isVisible && (
        <QuickviewComponent closeAction={hide} productData={productData} />
      )}
    </>
  )
}

VariantButton.propTypes = {
  productData: PropTypes.object,
  className: PropTypes.string,
  variant: PropTypes.string,
  text: PropTypes.string,
}

export default VariantButton
